"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildBadgeImageUrl = exports.BadgeServiceQueryType = void 0;

var _avatarConstants = require("./avatarConstants");

var BadgeServiceQueryType;
exports.BadgeServiceQueryType = BadgeServiceQueryType;

(function (BadgeServiceQueryType) {
  BadgeServiceQueryType["PersonID"] = "personid";
  BadgeServiceQueryType["EmployeeID"] = "employeeid";
  BadgeServiceQueryType["Login"] = "login";
})(BadgeServiceQueryType || (exports.BadgeServiceQueryType = BadgeServiceQueryType = {}));

var buildBadgeImageUrl = function buildBadgeImageUrl(query) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$isFullSize = _ref.isFullSize,
      isFullSize = _ref$isFullSize === void 0 ? false : _ref$isFullSize,
      _ref$queryType = _ref.queryType,
      queryType = _ref$queryType === void 0 ? BadgeServiceQueryType.Login : _ref$queryType;

  return "".concat(_avatarConstants.BADGE_PHOTO_URL, "?").concat(queryType, "=").concat(query, "&fullsize=").concat(isFullSize);
};

exports.buildBadgeImageUrl = buildBadgeImageUrl;